import { Typography, TypographyProps } from '@material-ui/core';
import React from 'react';
import styled from '../../styled';

const StyledHeadline = styled(Typography)`
  font-weight: 700;
  color: #0e1c2b;
  font-family: 'Merriweather', serif;
  letter-spacing: -2%;
  margin: 0;

  /* Use Material-UI typography variant font sizes */
  &.MuiTypography-h1 {
    font-size: ${(p) => p.theme.typography.h1.fontSize};
    line-height: ${(p) => p.theme.typography.h1.lineHeight};

    @media (max-width: 960px) {
      font-size: ${(p) => p.theme.typography.h2.fontSize};
    }

    @media (max-width: 600px) {
      font-size: ${(p) => p.theme.typography.h3.fontSize};
    }
  }

  &.MuiTypography-h2 {
    font-size: ${(p) => p.theme.typography.h2.fontSize};
    line-height: ${(p) => p.theme.typography.h2.lineHeight};

    @media (max-width: 960px) {
      font-size: ${(p) => p.theme.typography.h3.fontSize};
    }

    @media (max-width: 600px) {
      font-size: ${(p) => p.theme.typography.h4.fontSize};
    }
  }

  &.MuiTypography-h3 {
    font-size: ${(p) => p.theme.typography.h3.fontSize};
    line-height: ${(p) => p.theme.typography.h3.lineHeight};

    @media (max-width: 960px) {
      font-size: ${(p) => p.theme.typography.h4.fontSize};
    }

    @media (max-width: 600px) {
      font-size: ${(p) => p.theme.typography.h5.fontSize};
    }
  }

  &.MuiTypography-h4 {
    font-size: ${(p) => p.theme.typography.h4.fontSize};
    line-height: ${(p) => p.theme.typography.h4.lineHeight};
  }

  &.MuiTypography-h5 {
    font-size: ${(p) => p.theme.typography.h5.fontSize};
    line-height: ${(p) => p.theme.typography.h5.lineHeight};
  }

  &.MuiTypography-h6 {
    font-size: ${(p) => p.theme.typography.h6.fontSize};
    line-height: ${(p) => p.theme.typography.h6.lineHeight};
  }
` as typeof Typography;

export const Headline = ({
  children,
  component = 'h2',
  variant,
  ...props
}: {
  children: React.ReactNode;
  component?: React.ElementType;
  variant?: TypographyProps['variant'];
  [key: string]: any;
}) => {
  // If variant is not provided, infer it from component
  const inferredVariant =
    variant ||
    (typeof component === 'string' && component.match(/^h[1-6]$/)
      ? (component as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6')
      : 'h2');

  return (
    <StyledHeadline component={component} variant={inferredVariant} {...props}>
      {children}
    </StyledHeadline>
  );
};
